<template>
  <div v-if="visible" class="pay-overlay">
    <div class="pay-toast" :class="type">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: 'AuthorizePayOverlay',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: '' },
    type: {
      type: String,
      default: 'error',
      validator: (v) => ['error', 'wait'].includes(v),
    },
  },
};
</script>

<style scoped>
.pay-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  pointer-events: none;
}

.pay-toast {
  max-width: 320px;
  padding: 18px 22px;
  border-radius: 12px;
  font-size: 15px;
  line-height: 1.55;
  text-align: center;
  color: #fff;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

.pay-toast.error,
.pay-toast.wait {
  background: #8b1a1a;
}
</style>
